module.exports = __webpack_public_path__ + "img/arrow.4e861f5f.svg";